import { SxProps } from '@mui/material';

export const muiStyles: Record<string, SxProps> = {
  chip: {
    '&.MuiChip-root': {
      padding: '4px 8px',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      height: { xs: '18px', xl: '22px' },
      borderRadius: '50px',
    },
    '& .MuiChip-label': {
      padding: 0,
    },
  },
  chipLabel: { display: 'flex', alignItems: 'center' },
};
